import React, { useEffect } from "react";
import { useIsMobile } from "../../../../Hooks";
import useStyles from "./FmProductTitle.style";
import { FarmerPractice } from "../../../../Models";
import { ShowWhen } from "../../../../Components/ShowWhen";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../Redux";
import { convertToImperial } from "../../../../Constants/Calculations";

interface FmProductTitleProps {
    title: string;
    nutrients: FarmerPractice | null;
    unitValue: number;
    unitType: string;
    farmerPracrice?: FarmerPractice;
}

const FmProductTitle = ({ title, nutrients, unitValue, unitType, farmerPracrice }: FmProductTitleProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    const measureUnit = useSelector((state: RootState) => state.general.activeMetricMethod);

    function isFP() {
        return farmerPracrice != undefined;
    }

    useEffect(() => {
        console.log("isfp?", isFP());
    }, []);

    return (
        <div className={classes.container}>
            <div className={classes.mainTitle}>
                <span className={isMobile ? classes.mobile_title : classes.title}>{title}</span>
            </div>

            {isFP() ? (
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                    {/* <span>Farmer Practice: </span> */}
                    <div className={isMobile ? classes.mobile_npk : classes.npk}>
                        <span style={{ marginLeft: 7 }}>{`N ${measureUnit === "1" ? farmerPracrice?.n : convertToImperial(farmerPracrice?.n || 0)}`}</span>
                        <span style={{ marginLeft: 7 }}>{`P2O5 ${measureUnit === "1" ? farmerPracrice?.p : convertToImperial(farmerPracrice?.p || 0)}`}</span>
                        <span style={{ marginLeft: 7 }}>{`K2O ${measureUnit === "1" ? farmerPracrice?.k : convertToImperial(farmerPracrice?.k || 0)}`}</span>
                        <span style={{ marginLeft: 7 }}>{`${unitValue} ${unitType}`}</span>
                    </div>
                </Stack>
            ) : (
                <div className={isMobile ? classes.mobile_npk : classes.npk}>
                    <span>{`N ${nutrients ? nutrients.n : 0}`}</span>
                    <span style={{ marginLeft: 7 }}>{`P2O5 ${nutrients ? nutrients.p : 0}`}</span>
                    <span style={{ marginLeft: 7 }}>{`K2O ${nutrients ? nutrients.k : 0}`}</span>
                    <span style={{ marginLeft: 7 }}>{`${unitValue} ${unitType}`}</span>
                </div>
            )}
        </div>
    );
};

export default FmProductTitle;
